export const DEFAULT_UPVALUE_EMOJI = '⬆︎'
export const DEFAULT_SEED_EMOJI = '🌱'

export function isDefaultUpvalueEmoji(emoji?: string | null): boolean {
    // Accept both variants for backwards compatibility with stored values.
    return emoji === DEFAULT_UPVALUE_EMOJI || emoji === '⬆️'
}

export function isSeedEmoji(emoji?: string | null): boolean {
    return emoji === DEFAULT_SEED_EMOJI
}
